import { useQuery } from "@tanstack/react-query";
import activityService from "../../services/activityService";
import { queryKeys } from "./queryKeys";

export const useRecentActivities = (options = {}) => {
  const { limit = 10, enabled = true } = options;

  return useQuery({
    queryKey: [...queryKeys.activities.all, { limit }],
    queryFn: () =>
      activityService.getMyRecentActivities({
        limit,
      }),
    enabled,
    staleTime: 60 * 1000,
  });
};

